import React from 'react';
import PropTypes from 'prop-types';
import { useRouteActionsMenuPermissions } from './hooks/useRouteActionsMenuPermissions';
import { useRouteActions } from './hooks/useRouteActions';
import { createRouteMenuItems } from './factories/routeActionsMenuFactory';
import Shortcut from '../components/Shortcut';

/**
 * RouteActionsMenu component - displays action menu for routes
 */
export default function RouteActionsMenu({ route, equipmentAssignments }) {
  const permissions = useRouteActionsMenuPermissions();
  const routeActions = useRouteActions(route);

  const menus = createRouteMenuItems(
    routeActions,
    route,
    equipmentAssignments,
    permissions
  );

  return <Shortcut menus={menus} />;
}

RouteActionsMenu.propTypes = {
  route: PropTypes.object.isRequired,
  equipmentAssignments: PropTypes.arrayOf(PropTypes.object).isRequired
};
